﻿
angular.module("fliptoWeb")
    .directive("ftGetStarted", ["$compile", "$animate", "timezones", "callTimes", "ApiService", "$analytics", "$window", "$location",
        ($compile, $animate, timezones, callTimes, ApiService, $analytics, $window, $location) => {

        var templateUrl = "get-started.html";

        // TO DO: Need to have dev dynamically generate analytics-label based on where intial click came from. //
        var trackingInfo = {
            // TO DO: Dev, please remove if this isn't used //
            submitFormDiscovery: {
                eventName: "Get-Started: Discovery Form Submit",
                eventProperties: {
                    category: "Get-Started: Discovery Form Submit",
                    label: "Get-Started: Discovery Form Submit"
                }
            },
            submitFormDemo: {
                eventName: "submitted demo request form",
                eventProperties: {
                    category: "demo requests",
                    label: "top nav demo request"
                }
            },
            // TO DO: Dev, please remove if this isn't used //
            submitFormSignup: {
                eventName: "Get-Started: Signup Form Submit",
                eventProperties: {
                    category: "Get-Started: Signup Form Submit",
                    label: "Get-Started: Signup Form Submit"
                }
            },
            submitSuccess: {
                eventName: "successful demo request form submit",
                eventProperties: {
                    category: "demo requests",
                    label: "top nav demo request"
                }
            },
            submitFail: {
                eventName: "failed demo request form submit",
                eventProperties: {
                    category: "demo requests",
                    label: "top nav demo request"
                }
            }
        }

        return {
            restrict: "AE",
            replace: true,
            templateUrl: "get-started.html",
            scope: {
                accessor: "=",
                sectionChangeAccessor: "&"
            },
            link(scope, elem, attrs) {

                //gets active section from controller
                //NEW DEFAULT IS ACTIVE SECTION 3 AND NO LONGER IS BASED ON CONTROLLER!!!!
                scope.activeSection = scope.accessor.activeSection || 0;
                //scope.activeSection = 3;

                //binds change handler from controller to directive
                scope.activateSection = scope.accessor.activateSection;

                //Creates a method on the accessor for communication from controller to directive
                scope.accessor.updateSection = section => {
                    scope.errorMessage = "";
                    //somehow somewhere this is getting called with a value of true.... I can't find where.
                    if (typeof section === "number")
                        scope.activeSection = section;
                }

                scope.hasBeenSubmitted = scope.accessor.hasBeenSubmitted;
                scope.setSubmittedState = scope.accessor.setSubmittedState;

                scope.firstName = "";
                scope.lastName = "";
                scope.email = "";
                scope.phone = "";
                scope.timezone = null;
                scope.callTime = null;
                scope.notes = "";

                /*
                 * None = 0,
                 * SingleProperty = 1,
                 * ManagementGroup = 2,
                 * Destination = 3,
                 * MarketingAgency = 4,
                 * SomethingAwesome = 99
                 */
                scope.leadType = 0;
                scope.hotelInfo = "";
                scope.url = "";

                scope.bookingEngine = "";
                scope.isSignupOver100Month = false;
                scope.isADROver65 = false;
                scope.roomCount = "";

                scope.timezones = timezones.list;

                scope.callTimes = callTimes.list;

                scope.leadTypes = [
                    {
                        value: 1,
                        description: "A single property",
                        descriptionFull: "I represent a single property"
                    },
                    {
                        value: 2,
                        description: "Several properties",
                        descriptionFull: "I represent several properties"
                    },
                    {
                        value: 3,
                        description: "A destination",
                        descriptionFull: "I represent a destination"
                    },
                    {
                        value: 4,
                        description: "A marketing agency",
                        descriptionFull: "I represent a marketing agency"
                    },
                    {
                        value: 99,
                        description: "Something else",
                        descriptionFull: "I represent something else"
                    }
                ];

                scope.showNotes = false;

                scope.activateNotes = () => {
                    scope.showNotes = true;
                }

                scope.errorMessage = "";

                scope.processingRequest = false;

                scope.submit = () => {
                    scope.errorMessage = "";
                    scope.processingRequest = true;
                    

                    var data = {
                        //Partner: null,
                        ContactType: scope.activeSection,
                        Company: scope.hotelInfo,
                        Email: scope.email,
                        First: scope.firstName,
                        Last: scope.lastName,
                        Phone: scope.phone,
                        Type: scope.leadType.value,
                        Url: scope.url,
                        Description: scope.notes,
                        ExtendedData: []
                    }

                    /*
                     * Contact Type
                     * public enum ContactType
                     * ContactForm = 0,
                     * PartnerSignup = 1,
                     * DiscoveryRequest = 2,
                     * SelfGuidedDemoRequest = 3,
                     * FullDemoRequest = 4,
                     */
                    if (scope.activeSection === 3 || scope.activeSection === 4) {
                        $analytics.eventTrack(trackingInfo.submitFormDemo.eventName, trackingInfo.submitFormDemo.eventProperties);
                    }

                    if (scope.bookingEngine)
                        data.ExtendedData.push({ Key: "Booking-Engine", Value: scope.bookingEngine });
                    if (scope.isSignupOver100Month)
                        data.ExtendedData.push({ Key: "Is-Signup-Over-100-Month", Value: scope.isSignupOver100Month });
                    if (scope.isADROver65)
                        data.ExtendedData.push({ Key: "Is-ADR-Over-65", Value: scope.isADROver65 });
                    if (scope.roomCount)
                        data.ExtendedData.push({ Key: "Room-Count", Value: scope.roomCount });
                    if (scope.callTime)
                        data.ExtendedData.push({ Key: "Best-Time-To-Call", Value: scope.callTime.description });
                    if (scope.timezone)
                        data.ExtendedData.push({ Key: "Best-Time-To-Call-Timezone", Value: scope.timezone.code });

                    data.ExtendedData.push({ Key: "Source Url", Value: $location.absUrl() });

                    //todo: turn this into a utility service
                    var analyticsData = ((obj) => {
                        var dataObj = {};
                        for (var i in obj) {
                            if (obj.hasOwnProperty(i) && i !== "ExtendedData") {
                                dataObj[i] = data[i];
                            } else if (obj.hasOwnProperty(i) && i === "ExtendedData") {
                                angular.forEach(obj[i], item => {
                                    dataObj[item.Key] = item.Value;
                                });
                            }
                        }
                        return dataObj;
                    })(data);

                    $analytics.setUsername(data.Email || data.First + ' ' + data.Last);
                    $analytics.setUserProperties(analyticsData);

                    ApiService.GetStarted_Post(data)
                        .then(response => {

                            if (response.data.Success) {
                                scope.activateSection(10);
                                scope.setSubmittedState(true);
                                $analytics.eventTrack(trackingInfo.submitSuccess.eventName, trackingInfo.submitSuccess.eventProperties);
                            } else {
                                $analytics.eventTrack(trackingInfo.submitFail.eventName, trackingInfo.submitFail.eventProperties);
                                scope.errorMessage = response.data.Message;
                            }

                            scope.processingRequest = false;
                        },
                        response => {
                            scope.errorMessage = !!response.data && !!response.data.MessageMessage ? response.data.Message : "Something terrible happened";
                            scope.processingRequest = false;   
                        });
                }

                // Turn on cloudflare turnstile
                elem[0].querySelectorAll(".turnstile-widget.form-group").forEach(widget => {
                    globalThis.turnstile?.render(widget, {
                        sitekey: widget.getAttribute("data-sitekey"),
                        callback: (token) => {
                            setTimeout(() => {
                                widget.classList.add("d-none");
                            }, 1000);
                        },
                    });
                });
            }
        };


    }]);